export const sortLabels = ['hot', 'new', 'active', 'top'];
